import { evidenceDiaryDetailSearchFields } from './fields'

export const evidenceDiaryDetailSearchValidation = (data) => {
    return {
        initialValues: {
            [evidenceDiaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID]: data?.[evidenceDiaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID] ?? '',
            [evidenceDiaryDetailSearchFields.FULL_NAME_SELLER]: data?.[evidenceDiaryDetailSearchFields.FULL_NAME_SELLER] ?? '',
            [evidenceDiaryDetailSearchFields.LOCATION]: data?.[evidenceDiaryDetailSearchFields.LOCATION] ?? '',
            [evidenceDiaryDetailSearchFields.STREET]: data?.[evidenceDiaryDetailSearchFields.STREET] ?? '',
            [evidenceDiaryDetailSearchFields.PRICE_FROM]: data?.[evidenceDiaryDetailSearchFields.PRICE_FROM] ?? '',
            [evidenceDiaryDetailSearchFields.PRICE_TO]: data?.[evidenceDiaryDetailSearchFields.PRICE_TO] ?? '',
            [evidenceDiaryDetailSearchFields.CREATED_FROM]: data?.[evidenceDiaryDetailSearchFields.CREATED_FROM] ?? '',
            [evidenceDiaryDetailSearchFields.CREATED_TO]: data?.[evidenceDiaryDetailSearchFields.CREATED_TO] ?? '',
        },
    }
}
